import React from 'react';

import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { $getNodeByKey } from 'lexical';
import { useImpressionEditorContext } from '../../../Context';
import { InlineAttachment } from '../../../../Attachments/InlineAttachment';

type AttachmentProps = {
  footnoteId: string;
  nodeKey: string;
};

export const Attachment = ({ footnoteId, nodeKey }: AttachmentProps) => {
  const { isEditing, viewMode, patient, activeImpression } =
    useImpressionEditorContext();
  const [editor] = useLexicalComposerContext();
  const effectiveIsEditing = isEditing && editor.isEditable();

  const handleDelete = () => {
    editor.update(() => {
      const node = $getNodeByKey(nodeKey);
      if (node) {
        node.remove();
      }
    });
  };

  if (!activeImpression) {
    return null;
  }

  return (
    <InlineAttachment
      footnoteId={footnoteId}
      onDelete={handleDelete}
      viewMode={viewMode}
      isEditing={effectiveIsEditing}
      patient={patient}
      impression={activeImpression}
      text={''}
    />
  );
};
